export default "__VITE_ASSET__$zu9ticY__"